import {FC} from 'react';

import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import {TypeAlign} from '../../../shared/types/table.types';

const headCells = [
  {
    disablePadding: false,
    id: 'modelName',
    label: 'Название модели',
    align: 'left',
  },
  {
    disablePadding: false,
    id: 'years',
    label: 'МПИ в годах',
    align: 'left',
  },
  {
    disablePadding: false,
    id: 'fazes',
    label: 'Фазность',
    align: 'left',
  },
  {
    disablePadding: false,
    id: 'tariffs',
    label: 'Тарифность',
    align: 'left',
  },
];

export const TableHeadContainer: FC = () => {
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align as TypeAlign}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sx={headCell.id === 'id' ? {width: '65px'} : undefined}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
